<div class="maintenance-lock">
  <!-- Dasselbe Logo und dieselbe Quelle wie die Fehlerseite, die andere bildschirmfüllende Maske. -->
  <img class="maintenance-lock__logo" [src]="'app_logo.png' | mpThemeAssetsPath | async" alt="Logo" />

  <mat-icon class="maintenance-lock__icon">build</mat-icon>

  <h1 class="maintenance-lock__title">Wartungsmodus</h1>

  @if (viewModel().announcementText) {
    <p class="maintenance-lock__text">{{ viewModel().announcementText }}</p>
  } @else {
    <p class="maintenance-lock__text">Die Plattform wird gerade gewartet und ist vorübergehend nicht verfügbar.</p>
  }

  @if (viewModel().countdown) {
    <p class="maintenance-lock__countdown-label">Voraussichtlich noch</p>
    <p class="maintenance-lock__countdown">{{ viewModel().countdown }}</p>
  }

  <p class="maintenance-lock__hint">Die Anwendung wird automatisch fortgesetzt.</p>

  <!--
    Hauptaktion farbig, Nebenaktion schlicht - dasselbe Paar wie im Bestätigungsdialog aus `@core/ui`.
    Der Organisationswechsel ist die Aktion, die aus der Sperre heraus wieder arbeitsfähig macht.
  -->
  <div class="maintenance-lock__actions">
    @if (viewModel().canSwitchOrganization) {
      <button mat-flat-button color="accent" type="button" (click)="switchOrganization.emit()">
        <mat-icon>swap_horiz</mat-icon>
        Organisation wechseln
      </button>
    }

    <button mat-button type="button" (click)="logoutRequested.emit()">
      <mat-icon>logout</mat-icon>
      Abmelden
    </button>
  </div>
</div>
